import { warn } from '../../../logger';
import { InternalElementFactoryOptions, SdkElement } from '../../../model';
import { recordEvent } from '../../../telemetry';
import { SDKError } from '../../error';
import { RecipientFieldsElement, RecipientFieldsElementOptions } from './RecipientFieldsElement';
import { parseRecipientFieldsOptions } from './recipientFieldsOptionsSchema';

export const createRecipientFieldsElement = async (
  elementOptions: RecipientFieldsElementOptions,
  commonOptions: InternalElementFactoryOptions
): Promise<SdkElement> => {
  await recordEvent('sdk_recipient_fields_element_init_options', {
    recipient_fields_element_options: { ...elementOptions },
    elements_options: commonOptions
  });

  const {
    errors,
    warnings,
    options: validatedOptions,
    initialOptions
  } = parseRecipientFieldsOptions(elementOptions);

  if (errors) {
    throw new SDKError(
      'invalidRecipientFieldsElementOptions',
      'Invalid Recipient Fields Element options provided.',
      errors
    );
  }

  if (warnings) {
    warn('invalidRecipientFieldsElementOptions', warnings);
  }

  await recordEvent('sdk_recipient_fields_element_options_validated', {
    recipient_fields_element_warnings: warnings,
    recipient_fields_element_options: initialOptions,
    elements_options: commonOptions
  });

  return RecipientFieldsElement({ ...validatedOptions, ...commonOptions });
};
